import { InjectionToken, type Provider } from '@angular/core';

/** The company the portal is currently bound to (from the BFF's GET /api/config). */
export interface ActiveCompany {
  resourceId: string;
  organizationId: string;
}

/**
 * The active company, badged in the shell so a dev running the global SPA against
 * `localhost` always sees WHICH company they're looking at (the anti-mix-up
 * guard). Null when unknown — a multi-tenant deploy, or the SPA fell back to
 * build-time config because `/api/config` was unreachable.
 */
export const ACTIVE_COMPANY = new InjectionToken<ActiveCompany | null>('ACTIVE_COMPANY');

/**
 * Provide the active company at app bootstrap, from the fetched runtime config:
 *
 *     provideActiveCompany(rc.company ?? null),
 */
export function provideActiveCompany(company: ActiveCompany | null): Provider[] {
  return [{ provide: ACTIVE_COMPANY, useValue: company }];
}
